import { RevealerManager } from "../../../modules/revealer/RevealerManager"
import { ReavealerState, Revealer } from "../../../modules/revealer/Revealer";
import { SanSpriteSymbol } from '../../../engine/Symbol/SanSpriteSymbol';
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { gsap } from "gsap";
import { GameConfig } from "../../../config/base/GameConfig";
import { SoundManager } from "../../../config/sound/SoundManager";
import { SoundConfig } from "../../../config/sound/SoundConfig";
import { Helper } from "../../../../core/utils/Helper";

export class ScatterRevealPresentation {

    public static revealBar(revealPos:number):gsap.core.Timeline[]{
        const revTop:Revealer = RevealerManager.getTopBar(revealPos);
        const revBott:Revealer = RevealerManager.getBotBar(revealPos);
        return [revTop.revealRes(), revBott.revealRes()];
    }

    public static BarsActive(revealPos:number):boolean{
        return RevealerManager.getTopBar(revealPos).isActive && RevealerManager.getBotBar(revealPos).isActive;
    }

    public static gotDoubleExpand(revealPos:number):boolean{
        return this.BarsActive(revealPos) && RevealerManager.getBotBar(revealPos).state.equal(ReavealerState.EXPANDING) &&  RevealerManager.getTopBar(revealPos).state.equal(ReavealerState.EXPANDING);
    }

    public static revealTwoMyst(revealPos:number,skipped?:boolean):gsap.core.Timeline{
        const revTop:Revealer = RevealerManager.getTopBar(revealPos);
        const revBott:Revealer = RevealerManager.getBotBar(revealPos);

        const tl = gsap.timeline({onComplete:() => {
            SanEngineManager.getReel(revealPos).applySymbolsFromXWays(revTop, true)
            revTop.didDoubleConnect();
            revBott.didDoubleConnect();
        }});

        if(revTop.isExpanded && revBott.isExpanded) {
            return tl;
        };

        const revDurr:number = RevealerManager.FullRevealer(revealPos).revealDurr;
        const durrExp: number = GameConfig.REEL_ENGINE_CONFIG.DURATION.EXPAND!;

        tl.add([
            revTop.expand(true,true),
            revBott.expand(true,true),
            () => { SoundManager.playSoundSkipEffect(SoundConfig.XWAYS_DOUBLE,SoundConfig.SKIP_XWAYSDOUBLE_BASEGAME,!!skipped) } 
        ],0);

        tl.add([
            RevealerManager.FullRevealer(revealPos).reveal(),
            revBott.expandRes(false),
            revTop.expandRes(false),
        ],durrExp);
        // tl.to(this,{duration:revDurr});
        tl.add(() => {SoundManager.playSoundEffect(SoundConfig.XWAY_REVEAL_DOUBLE)}, durrExp + revDurr/3);
        return tl;
    }

    public static doReelSplit(rev: Revealer, reelID:number): gsap.core.Timeline {

        const reelSym: SanSpriteSymbol[] = <SanSpriteSymbol[]>SanEngineManager.getReel(reelID).AllWindowSymbols;
        const tl: gsap.core.Timeline = Helper.setTimeline();

        let index: number = rev.isTop ? 0 : reelSym.length - 1;
        for (let k: number = 0; k < reelSym.length; k++) {
            const timeOffset:number = k * GameConfig.SPLIT_OFFSET;
            if (reelSym[index].isNormalSym && !reelSym[index].transformedScatter) {
                tl.add(reelSym[index].doSplit(), timeOffset);
                tl.add(() => { SoundManager.playSoundEffect(SoundConfig.WILD_SPLIT) }, timeOffset);
            }else if(reelSym[index].transformedScatter || reelSym[index].isJumpWild){
                tl.add(reelSym[index].MarkedForExtraSplit(true,1), timeOffset);
                tl.add(() => {
                    SoundManager.playSoundEffect(SoundConfig.BONUS_WILD_FIRE,undefined,true);
                },timeOffset)
               
            }
            index += rev.isTop ? 1 : -1;
        }

        return tl;
    }

    public static flashBar(pos:number): gsap.core.Timeline {
        RevealerManager.getBotBar(pos).flashBeforeStop();
        return RevealerManager.getTopBar(pos).flashBeforeStop();
    }

    public static flashBarOnce(pos:number,top:boolean): gsap.core.Timeline {
        const rev:Revealer = top ? RevealerManager.getTopBar(pos) : RevealerManager.getBotBar(pos);
        return rev.flashOnce();
    }

    public static flashBarFS(pos:number,top:boolean): gsap.core.Timeline {
        const rev:Revealer = top ? RevealerManager.getTopBar(pos) : RevealerManager.getBotBar(pos);
        return rev.flashBeforeStop();
    }

    public static revealBarFS(pos:number ,top:boolean): gsap.core.Timeline {
        const rev:Revealer = top ? RevealerManager.getTopBar(pos) : RevealerManager.getBotBar(pos);
        return rev.revealRes();
    }
}
